import { useState } from 'react';
import { InformationCircleIcon } from '@heroicons/react/24/outline';

import FeeDetailsModal from 'shared/FeeDetailsModal';
import { closeModal, openModal } from 'utils/globalUtils';

function TaxesApply() {
    const [feeDetailsModal, setFeeDetailsModal] = useState(false);

    const openFeeDetailsModal = () => {
        openModal(setFeeDetailsModal);
    };

    const closeFeeDetailsModal = () => {
        closeModal(setFeeDetailsModal);
    };

    return (
        <>
            <button
                type="button"
                className="text-body-xs flex items-center gap-10 text-grey"
                onClick={openFeeDetailsModal}
            >
                <span>Additional taxes and fees may apply.</span> <InformationCircleIcon width="12px" />
            </button>

            <FeeDetailsModal feeDetailsModal={feeDetailsModal} closeFeeDetailsModal={closeFeeDetailsModal} />
        </>
    );
}

export default TaxesApply;
